const colsMap = {
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
};

const SquareCluster = ({
  className = "",
  cols = 3,
  count = 6,
  size = "",
  gap = "gap-2",
  opacity = "opacity-20",
  rotate = "",
  blur = "",
}) => {
  return (
    <div
      className={`fixed ${size} grid ${colsMap[cols]} ${gap} ${opacity} ${rotate} ${blur} ${className}`}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={`aspect-square rounded-lg ${
            i % 2 ? "bg-[#FFD8CE]" : "bg-[#FF6943]"
          }`}
        />
      ))}
    </div>
  );
};

export default function DecorativeSquares() {
  return (
    <div className="hidden md:block pointer-events-none z-0">
      {/* Top-left */}
      <SquareCluster
        className="top-10 left-10"
        size="w-48 h-48"
        cols={3}
        count={9}
        rotate="rotate-12"
      />

      {/* Upper-right */}
      <SquareCluster
        className="top-32 right-24"
        size="w-24 h-24"
        cols={2}
        count={4}
        opacity="opacity-10"
        rotate="-rotate-6"
      />

      {/* Mid-right */}
      <SquareCluster
        className="top-1/3 -right-10"
        size="w-36 h-36"
        cols={2}
        count={4}
        opacity="opacity-15"
        rotate="rotate-6"
      />

      {/* Bottom-left */}
      <SquareCluster
        className="bottom-32 left-24"
        size="w-20 h-20"
        cols={2}
        count={4}
        opacity="opacity-10"
        rotate="rotate-12"
      />

      {/* Bottom-right */}
      <SquareCluster
        className="bottom-16 right-40"
        size="w-40 h-40"
        cols={3}
        count={6}
        opacity="opacity-10"
        rotate="-rotate-12"
        blur="blur-[1px]"
      />
    </div>
  );
}
